const MessageType = {
    Unknown: 0,
    CreatePurchaseInvoices: 1,
    CreateSalesInvoice: 2,
    CreateAccountingReport: 3,
    CreateKelaProvisionInvoices: 4,
    CalculateInvoiceSummaryData: 5,
    HandleTaxiCardPayment: 6,
    CreateInvoicesByFilter: 7,
    VerifyInvoicesByFilter: 8
};

export default MessageType;
